module.exports = __webpack_public_path__ + "static/media/ru.3f61c2dd.svg";